<template>
  <div v-if="componentReady" class="container-wrapper service-request-page">
    <BackLink
      :to="backButton.route"
      :text="backButton.text"
    />

    <section class="container">
      <h1>{{ pageData.title }}</h1>

      <CarInfo
        :image="{ src: pageData.car.image, alt: pageData.car.year}"
        :year="pageData.car.year"
        :modification="pageData.car.modification"
      />

      <PeriodRange
        :key="`range-${pageData.range.selectedValue}`"
        :value="form.periodId"
        :title="pageData.range.title"
        :steps="pageData.range.steps"
        disabled
      />

      <div class="service-request-page__form">
        <!-- DISABLED FIELDS ROW -->
        <div class="service-request-page__form-filters">
          <BaseInput
            :key="`city-${pageData.filters.city.value}`"
            :value="pageData.filters.city.text"
            :label="pageData.filters.city.label"
            disabled
            class="service-request-page__form-input"
          />
          <BaseInput
            v-model="form.tel"
            :label="pageData.form.tel.label"
            :required="pageData.form.tel.required"
            :errorMsg="errorMsgs.tel"
            type="tel"
            mask="tel"
            class="service-request-page__form-input"
          />
        </div>
        <!-- DISABLED FIELDS ROW -->

        <div class="service-request-page__form-fields">
          <!-- COLUMN 1 -->
          <div class="service-request-page__form-col">
            <!-- <BaseSelect
              v-model="form.appeal"
              :items="pageData.form.appeal.items"
              :label="pageData.form.appeal.label"
              :placeholder="pageData.form.appeal.placeholder"
              :required="pageData.form.appeal.required"
              :errorMsg="errorMsgs.appeal"
              class="service-request-page__form-input"
            /> -->
            <BaseInput
              v-model="form.firstName"
              :label="pageData.form.firstName.label"
              :required="pageData.form.firstName.required"
              :errorMsg="errorMsgs.firstName"
              class="service-request-page__form-input"
            />
            <BaseInput
              v-model="form.lastName"
              :label="pageData.form.lastName.label"
              :required="pageData.form.lastName.required"
              :errorMsg="errorMsgs.lastName"
              class="service-request-page__form-input"
            />
            <BaseInput
              v-model="form.middleName"
              :label="pageData.form.middleName.label"
              :required="pageData.form.middleName.required"
              :errorMsg="errorMsgs.middleName"
              class="service-request-page__form-input"
            />
            <BaseInput
              :key="`dealer-${pageData.filters.dealer.value}`"
              :value="pageData.filters.dealer.text"
              :label="pageData.filters.dealer.label"
              disabled
              class="service-request-page__form-input"
            />
            <BaseInput
              v-if="pageData.form.comment"
              v-model="form.comment"
              :label="pageData.form.comment.label"
              :required="pageData.form.comment.required"
              :errorMsg="errorMsgs.comment"
              class="service-request-page__form-input"
            />
          </div>
          <!-- COLUMN 1 -->

          <!-- COLUMN 2 -->
          <div class="service-request-page__form-col">
            <BaseInput
              v-model="form.email"
              :label="pageData.form.email.label"
              :required="pageData.form.email.required"
              :errorMsg="errorMsgs.email"
              type="email"
              class="service-request-page__form-input"
            />
            <BaseSelect
              v-model="form.connectType"
              :items="pageData.form.connectType.items"
              :label="pageData.form.connectType.label"
              :placeholder="pageData.form.connectType.placeholder"
              :required="pageData.form.connectType.required"
              :errorMsg="errorMsgs.connectType"
              class="service-request-page__form-input"
            />
            <BaseInput
              v-model="form.carNumber"
              :label="pageData.form.carNumber.label"
              :required="pageData.form.carNumber.required"
              :errorMsg="errorMsgs.carNumber"
              class="service-request-page__form-input"
            />
            <BaseDatePicker
              v-if="pageData.form.dateTime.options.schedule"
              :label="pageData.form.dateTime.label"
              :required="pageData.form.dateTime.required"
              :buttonsText="pageData.form.dateTime.buttonsText"
              :options="datepickerOptions"
              :errorMsg="errorMsgs.dateTime"
              class="service-request-page__form-input"
              @input="form.dateTime = $event"
            />
          </div>
          <!-- COLUMN 2 -->
        </div>
      </div>

      <TablePrice
        :rows="pageData.priceTable.rows"
        :warning="pageData.priceTable.warning"
        noPadding
        class="service-request-page__table"
      />

      <div class="service-request-page__policy">
        <BaseCheckbox
          v-model="form.policy"
          :errorMsg="errorMsgs.policy"
        >
          <router-link
            :to="policyLink"
            class="simple-link"
          >
            {{ pageData.policy }}
          </router-link>
        </BaseCheckbox>
      </div>

      <div class="service-request-page__marketing_agree">
        <BaseCheckbox
          v-model="form.marketing_agree"
          :errorMsg="errorMsgs.marketing_agree"
        >
          <router-link
            :to="marketingLink"
            class="simple-link"
          >
            {{ pageData.form.marketing_agree.label }}
          </router-link>
        </BaseCheckbox>
      </div>

      <div class="service-request-page__submit-button-container">
        <BaseButton
          :disabled="!form.policy"
          @click.native="submitForm"
        >
          {{ pageData.submitButtonText }}
        </BaseButton>
      </div>
    </section>
  </div>
</template>

<script>
  // Step 5

  import { get } from 'lodash'
  import { mapGetters, mapActions } from 'vuex'
  import BackLink from '@/components/BackLink'
  import CarInfo from '@/components/CarInfo'
  import PeriodRange from '@/components/PeriodRange'
  import TablePrice from '@/components/TablePrice'
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'ServiceRequestPage',
    components: {
      BackLink,
      CarInfo,
      PeriodRange,
      TablePrice
    },
    data () {
      return {
        pageData: {},
        form: {
          vin: '',
          open_campaigns: '',
          price: '',
          periodId: '',
          dealerId: '',
          appeal: '',
          connectType: 'phone',
          firstName: '',
          lastName: '',
          middleName: '',
          tel: '+',
          email: '',
          carNumber: '',
          dateTime: '',
          comment: '',
          policy: true,
          marketing_agree: false
        },
        componentReady: false,
        errorMsgs: {}
      }
    },
    computed: {
      ...mapGetters([
        'getModel',
        'getYear',
        'getModification',
        'getPeriod',
        'getCity',
        'getAliasParamCity',
        'getDealer',
        'getAliasParamDealer',
        'getOilId',
        'getDiyaData'
      ]),
      backButton () {
        const lang = this.$store.state.currentLang
        const queryLang = lang !== DEFAULT_LANG ? { lang } : {}

        const text = this.pageData.backButtonText
        const route = {
          name: 'tech-map',
          params: {
            model: this.getModel,
            year: this.getYear,
            modification: this.getModification
          },
          query: {
            period: this.getPeriod,
            city: this.getCity || this.getAliasParamCity,
            dealer: this.getDealer || this.getAliasParamDealer,
            ...queryLang
          }
        }

        return { text, route }
      },
      datepickerOptions () {
        return {
          ...this.pageData.form.dateTime.options,
          requestServiceIn: this.pageData.filters.dealer.requestServiceIn
        }
      },
      marketingLink () {
        const lang = this.$store.state.currentLang
        const query = lang !== DEFAULT_LANG ? { lang } : {}
        return { path: '/marketing', ...query }
      },
      policyLink () {
        const lang = this.$store.state.currentLang
        const query = lang !== DEFAULT_LANG ? { lang } : {}
        return { path: '/policy', ...query }
      }
    },
    watch: {
      $route (to, from) {
        if (this.componentReady && (from.name === 'tech-map' && to.name === 'service-request')) {
          this.modelTextState()
          this.modelIdState()
          this.pushDataToDataLayer({
            page: {
              category: 'tools',
              subCategory: 'maintenance',
              sectionlv1: 'tool',
              sectionlv2: 'maintenance-calculator',
              language: this.$store.state.currentLang
            },
            event: {
              name: 'formevent',
              componentName: 'maintenance-quote-request',
              componentGroup: 'forms',
              action: 'form-step',
              label: 'contact-details'
            },
            workflow: {
              name: 'maintenance-calculator',
              step: 'configure-product',
              conversion: '0'
            },
            form: {
              name: 'lead-maintenance-quote-request',
              step: 'contact-details',
              conversion: '0'
            },
            product: [{
              category: 'cars',
              subCategory: 'new-cars',
              productInfo: {
                productId: this.modelId,
                productName: this.modelText,
                tmeModelId: this.modelId,
                modelName: this.modelText
              }
            }],
            dealer: {
              name: this.dealerName,
              dealerId: this.dealerId,
              city: this.dealerCity,
              zipcode: this.zipcode
            }
          }, true)
        }
        if (this.componentReady && (from.name === 'thank-you' && to.name === 'tech-map')) {
          this.modelTextState()
          this.modelIdState()
          this.pushDataToDataLayer({
            page: {
              category: 'tools',
              subCategory: 'maintenance',
              sectionlv1: 'tool',
              sectionlv2: 'maintenance-calculator',
              language: this.$store.state.currentLang
            },
            event: {
              name: 'formevent',
              componentName: 'maintenance-quote-request',
              componentGroup: 'forms',
              action: 'form-step',
              label: 'form-submit'
            },
            workflow: {
              name: 'maintenance-calculator',
              step: 'configure-product',
              conversion: '0'
            },
            form: {
              name: 'lead-maintenance-quote-request',
              step: 'form-submit',
              conversion: '1'
            },
            product: [{
              category: 'cars',
              subCategory: 'new-cars',
              productInfo: {
                productId: this.modelId,
                productName: this.modelText,
                tmeModelId: this.modelId,
                modelName: this.modelText
              }
            }],
            dealer: {
              name: this.dealerName,
              dealerId: this.dealerId,
              city: this.dealerCity,
              zipcode: this.zipcode
            }
          }, true)
        }
      },
      componentReady (v) {
        if (v) {
          this.modelTextState()
          this.modelIdState()
          this.dealerDataState()
          this.dealerDataState()
          this.pushDataToDataLayer({
            page: {
              category: 'tools',
              subCategory: 'maintenance',
              sectionlv1: 'tool',
              sectionlv2: 'maintenance-calculator',
              language: this.$store.state.currentLang
            },
            event: {
              name: 'formevent',
              componentName: 'maintenance-quote-request',
              componentGroup: 'forms',
              action: 'form-step',
              label: 'contact-details'
            },
            workflow: {
              name: 'maintenance-calculator',
              step: 'configure-product',
              conversion: '0'
            },
            form: {
              name: 'lead-maintenance-quote-request',
              step: 'contact-details',
              conversion: '0'
            },
            product: [{
              category: 'cars',
              subCategory: 'new-cars',
              productInfo: {
                productId: this.modelId,
                productName: this.modelText,
                tmeModelId: this.modelId,
                modelName: this.modelText
              }
            }],
            dealer: {
              name: this.dealerName,
              dealerId: this.dealerId,
              city: this.dealerCity,
              zipcode: this.zipcode
            }
          }, true)
        }
      }
    },

    activated () {
      this.initPage()
    },

    beforeDestroy () {
      if (this.getOilId) this.$store.commit('SET_OIL_ID', '')
    },

    methods: {
      ...mapActions(['fetchServiceRequestPageData', 'submitServiceRequest']),
      async initPage () {
        const data = await this.fetchServiceRequestPageData({
          model: this.getModel,
          year: this.getYear,
          modification: this.getModification,
          period: this.getPeriod,
          city: this.getCity,
          dealer: this.getDealer,
          oil: this.getOilId,
          workpackages: this.$route.query.workpackages
        })

        this.pageData = { ...data }
        this.initForm()
        this.componentReady = true
      },
      initForm () {
        if (this.getOilId) this.form.oil = this.getOilId
        if (this.getDiyaData) {
          this.form.firstName = this.getDiyaData.firstName
          this.form.lastName = this.getDiyaData.lastName
          this.form.carNumber = this.getDiyaData.licensePlate
        }

        this.form.workpackages = this.$route.query.workpackages

        this.form.vin = this.$store.state.vinSearchData.vin
        this.form.open_campaigns = this.$store.state.vinSearchData.open_campaigns
        this.form.periodId = this.pageData.range.selectedValue
        this.form.dealerId = this.pageData.filters.dealer.value
        this.form.price = parseFloat(this.pageData.priceTable.rows[this.pageData.priceTable.rows.length - 3].value)
      },
      async submitForm () {
        this.errorMsgs = {}

        const payload = {
          ...this.form,
          dateTime: this.form.dateTime / 1000 // timestamp in seconds, not miliseconds
        }
        const lang = this.$store.state.currentLang
        const queryLang = lang !== DEFAULT_LANG ? { lang } : {}

        try {
          const errors = await this.submitServiceRequest({
            submitUrl: this.pageData.formSubmitUrl,
            form: payload,
            formName: 'ServiceRequestPage'
          })

          if (!errors || (errors.hasOwnProperty('length') && errors.length === 0)) {
            if (this.getOilId) this.$store.commit('SET_OIL_ID', '')

            this.modelTextState()
            this.modelIdState()
            this.dealerDataState()
            this.pushDataToDataLayer({
              page: {
                category: 'tools',
                subCategory: 'maintenance',
                sectionlv1: 'tool',
                sectionlv2: 'maintenance-calculator',
                language: this.$store.state.currentLang
              },
              event: {
                name: 'formevent',
                componentName: 'maintenance-quote-request',
                componentGroup: 'forms',
                action: 'form-step',
                label: 'form-submit'
              },
              workflow: {
                name: 'maintenance-calculator',
                step: 'configure-product',
                conversion: '0'
              },
              form: {
                name: 'lead-maintenance-quote-request',
                step: 'form-submit',
                conversion: '1'
              },
              product: [{
                category: 'cars',
                subCategory: 'new-cars',
                productInfo: {
                  productId: this.modelId,
                  productName: this.modelText,
                  tmeModelId: this.modelId,
                  modelName: this.modelText
                }
              }],
              dealer: {
                name: this.dealerName,
                dealerId: this.dealerId,
                city: this.dealerCity,
                zipcode: this.zipcode
              }
            }, true)

            this.$router.push({ name: 'thank-you', query: { ...queryLang } })
          } else {
            Object.keys(errors)
              .forEach(errKey => {
                this.$set(this.errorMsgs, errKey, errors[errKey][0])
              })
          }
        } catch (e) {
          console.error('FAILED: submitServiceRequest')
          this.$router.push({ name: 'not-found', query: { ...queryLang } })
        }
      },
      modelTextState () {
        this.modelText = get(this, '$store.state.model.modelText', '') || get(this, 'pageData.car.toyotaModelName', '')
      },
      modelIdState () {
        this.modelId = get(this, '$store.state.model.modelId', '') || get(this, 'pageData.car.toyotaModelId', '')
      },
      dealerDataState () {
        this.dealerId = get(this, '$store.state.dealer.dealerId', '') || get(this, 'pageData.filters.dealer.dealerId', '')
        this.zipcode = get(this, '$store.state.dealer.zipcode', '') || get(this, 'pageData.filters.dealer.zipcode', '')
        this.dealerCity = get(this, '$store.state.dealer.dealerCity', '') || get(this, 'pageData.filters.city.text', '')
        this.dealerName = get(this, '$store.state.dealer.dealerName', '') || get(this, 'pageData.filters.dealer.text', '')
      },
      pushDataToDataLayer (params = {} || window.tngaDataLayer, pushDataLayer = false) {
        window.dataLayer = window.dataLayer || []
        window.tngaDataLayer = { ...params }

        if (pushDataLayer) window.dataLayer.push({ 'event': 'formevent' })
      }
    }
  }
</script>

<style lang="scss">
.service-request-page {
  padding-bottom: 70px;

  @include mobile {
    padding-bottom: 40px;
    overflow: hidden;
  }

  &__form {
    padding-bottom: 25px;
    margin-top: 70px;

    @include mobile {
      padding-bottom: 5px;
      margin-top: 40px;
    }

    border-bottom: 1px solid $c-gray;

    &-filters,
    &-fields {
      display: flex;
      justify-content: space-between;

      @include mobile {
        flex-direction: column;
      }
    }

    &-input {
      min-width: 335px;
      margin-bottom: 10px;

      @include mobile {
        min-width: 100%;
        margin-bottom: 5px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__table {
    margin: 40px 0;
    overflow: visible;

    @include mobile {
      margin: 20px 0;
    }
  }

  &__marketing_agree {
    display: flex;
    justify-content: center;

    @include mobile {
      margin-top: 30px;
    }
  }

  &__policy {
    display: flex;
    justify-content: center;

    @include mobile {
      margin-top: 30px;
    }
  }

  &__submit-button-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    @include mobile {
      margin-top: 10px;
    }
  }
}
</style>
